export default __webpack_public_path__ + "static/media/edit.cb25aa56.svg";